export class CidadaoLgpd {

    public static TermoLgpdAceito(): boolean {
        return Boolean(JSON.parse(localStorage.getItem('consumidor'))['aceitaTermosLGPD']);
    }
}





// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-lgpd/cidadao-lgpd.ts